<app-layout-container>
  <section class="contact-hero">
    <app-section-heading [animateTitle]="true"
                         animateTitleTrigger="in-view"
                         eyebrow="Contact Us"
                         title="Let’s talk about your team experience"
                         text="Tell us what you’re planning and we’ll help you shape the right next step for your team, event, or onboarding flow.">
    </app-section-heading>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="contact-grid-section">
    <div class="contact-grid">
      <article class="contact-card">
        <h3 class="contact-card__title">General Inquiries</h3>
        <p class="contact-card__text">
          Reach out to start the conversation, ask a question, or learn more about available services.
        </p>
        <p class="contact-card__detail">
          <strong>Email:</strong> billing@UnitedTeamBuilding.com
        </p>
      </article>

      <article class="contact-card">
        <h3 class="contact-card__title">Scheduling</h3>
        <p class="contact-card__text">
          For scheduling-related coordination or calendar-based booking workflows.
        </p>
        <p class="contact-card__detail">
          <strong>Email:</strong> scheduling@UnitedTeamBuilding.com
        </p>
      </article>

      <article class="contact-card">
        <h3 class="contact-card__title">Response Approach</h3>
        <p class="contact-card__text">
          The goal is a clear, professional, client-friendly process from the first contact through final planning.
        </p>
      </article>
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="contact-message-section">
    <div class="contact-form-onboarding__panel">
      <app-message-us-section></app-message-us-section>
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section id="bookings" class="contact-form-onboarding">
    <div class="contact-form-onboarding__panel">
      <app-onboarding-booking-section></app-onboarding-booking-section>
    </div>
  </section>
</app-layout-container>

<app-layout-container>
  <section class="contact-bottom-cta">
    <app-cta-banner [animateTitle]="true"
                    animateTitleTrigger="in-view"
                    eyebrow="Ready to move forward?"
                    title="We’d love to hear what you’re planning"
                    text="Share a few details and we can help you shape the right next step."
                    primaryLabel="Explore Services"
                    primaryLink="/services"
                    secondaryLabel="Read Testimonials"
                    secondaryLink="/testimonials">
    </app-cta-banner>
  </section>
</app-layout-container>
``
